import { createContext } from 'react';
import { createExternalStore } from '@/shared/libs/create-external-store';

export interface FullscreenState {
  isFullscreen: boolean;
  needFullscreenButton: boolean;
  headerEnabled: boolean;
  handler: (() => void) | null;
}

export interface FullscreenActions {
  setIsFullscreen: (value: boolean) => void;
  setNeedFullscreenButton: (value: boolean) => void;
  setHeaderEnabled: (value: boolean) => void;
  registerClickHandler: (fn: () => void) => void;
}

type FullscreenStore = ReturnType<typeof createExternalStore<FullscreenState>>;

export const FullscreenStoreContext = createContext<FullscreenStore | null>(null);
export const FullscreenActionsContext = createContext<FullscreenActions | null>(null);
